import { render, staticRenderFns } from "./MealRatingDialog.vue?vue&type=template&id=609467ca&scoped=true"
import script from "./MealRatingDialog.vue?vue&type=script&lang=js"
export * from "./MealRatingDialog.vue?vue&type=script&lang=js"
import style0 from "./MealRatingDialog.vue?vue&type=style&index=0&id=609467ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609467ca",
  null
  
)

export default component.exports